import { Component, DestroyRef, inject, Input } from '@angular/core';
import { EventService } from '@shared/services/event.service';
import { HelperService } from '@shared/services/helper.service';
import { EventConstants } from '@core/event-constants';
import { SessionService } from '@core/services/session.service';
import { AppBaseComponent } from '../app-component-base';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SPECIFIC_LIVE_ORGANIZATION_TOKEN_LIST } from '@tokens/specific-ogranization-token-list.token';
import { BehaviorSubject } from 'rxjs';
import { OnboardingService } from '@shared/services/onboarding/onboarding.service';
import { Router } from '@angular/router';
import { ApiService } from '@core/services/api.service';
import { AppConstants } from '@core/constants';
import { SagaStore } from '@features/onboarding/store/saga.store';

@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['sidebar-app.component.scss'],
})
export class SidebarMenuComponent extends AppBaseComponent {
  private onboardingService: OnboardingService = inject(OnboardingService);
  private router: Router = inject(Router);
  private apiService: ApiService = inject(ApiService);

  public ORGANIZATION_ID_LIST: number[] = inject(SPECIFIC_LIVE_ORGANIZATION_TOKEN_LIST);
  public v1Link: string = this.constant.V1_URL;
  public isLoggedIn: boolean = false;
  public isShowTestMenu: boolean = false;
  public isShowEconomy: boolean = false;
  public isShowSpeedRelationshipMenu: boolean = false;
  public isOnboardingComplete$: BehaviorSubject<boolean> = this.onboardingService.getOnboardingStatus();
  public isProductionEnv: boolean = this.helperService.isProductionEnvironment(
    location,
    AppConstants.ENVIRONMENT_URL.PROD
  );
  sagaStore = inject(SagaStore);

  @Input() public currentTestId: string = '';

  constructor(
    public sessionService: SessionService,
    private eventService: EventService,
    private readonly helperService: HelperService,
    private destroyRef: DestroyRef
  ) {
    super();
  }

  public onInitPage(): void {
    this.isLoggedIn = this.sessionService.isLoggedIn;
    this.eventService
      .GetEvent(EventConstants.APC.SELECT_TEST)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event): void => {
        this.isShowTestMenu = this.helperService.isShowTestDataMenu(event);
        this.isShowEconomy = this.helperService.isShowEconomyMenu(event);
        this.isShowSpeedRelationshipMenu = this.helperService.isShowSpeedRelationshipMenu(event);
      });
  }
}
